// file: raiseTicketPage.jsx
import React, { useEffect, useRef, useState } from "react";
import styles from "./completedTickets.module.scss";
import { connect, useDispatch } from "react-redux";
import {
  getAllSupportTicket,
  getAllUser,
  getOldMessages,
} from "../../store/actions";
import TicketTile from "../../components/uiComponents/ticketTile/TicketTile";
import SockJS from "sockjs-client";
import { Client, Stomp } from "@stomp/stompjs";
import {
  getObjectFromArrayOfObjects,
  getSimilarObjectsFromArray,
} from "../../utils/common/CommonFunctions";
import PROFILE_PIC from "../../assets/images/profileImg.png";
import colors from "../../colors";


const CompletedTickets = ({
  tickets,
  loginUser,
  messages,
  customers,
  users,
}) => {
  const [completed, setCompleted] = useState([]);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  const clientRef = useRef(null);
  const chatEndRef = useRef(null); // for auto-scroll
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [messagesList, setMessagesList] = useState([]);
  const [connected, setConnected] = useState(false);
  const [messageText, setMessageText] = useState("");

  const stompClientRef = useRef(null);
  let stompClient;

  //customer start
  const [showCustomerDetails, setShowCustomerDetails] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const getCustomerById = (userId) => {
    return getObjectFromArrayOfObjects(customers, "id", userId);
  };

  const handleCustomerClick = () => {
    const customer = getCustomerById(selectedTicket?.submittedUserId);
    console.log("customer", customer);
    setSelectedCustomer(customer);
    setShowCustomerDetails(true);
  };

  const closeCustomerDetails = () => {
    setShowCustomerDetails(false);
  };

  useEffect(() => {
    dispatch(getAllUser());
  }, []);

  //customer end

  useEffect(() => {
    setMessagesList(messages);
  }, [messages]);

  // 🔹 Load tickets
  useEffect(() => {
    dispatch(
      getAllSupportTicket({
        callback: {
          success: (data) => {
            const completed = data?.filter?.(
              (data) => data?.ticket?.status === 5
            );
            setCompleted(completed);
          },
        },
      })
    );
  }, [dispatch]);

  // const connect = (ticketId) => {
  //   const socket = new SockJS(
  //     `${process.env.REACT_APP_WEBSOCKET_BACKEND_URL}ws`
  //   );
  //   const stompClient = Stomp.over(socket);

  //   stompClient.connect({}, () => {
  //     console.log("Connected");
  //     setConnected(true);

  //     stompClient.subscribe(`/topic/ticket/${ticketId}`, (msg) => {
  //       console.log("Received:", msg.body);
  //       // Optionally update messages state
  //     });
  //   });

  //   stompClientRef.current = stompClient; // store in ref
  // };

  // const sendMessage = () => {
  //   if (!stompClientRef.current) return; // make sure it's connected

  //   const message = {
  //     ticketId: selectedTicket?.id,
  //     userId: loginUser?.id,
  //     message: messageText || "Testing chat message",
  //     timestamp: new Date().toISOString(),
  //     type: "message",
  //   };

  //   stompClientRef.current.send("/app/chat.send", {}, JSON.stringify(message));
  //   setMessagesList((pre) => [...pre, message]);
  //   setMessageText(""); // clear input
  // };

  const loadOldMessage = async (id) => {
    dispatch(
      getOldMessages({
        id: id,
        // callback: { success: (data) => setMessages(da) },
      })
    );
  };

  const handleClick = (item) => {
    console.log("id", item);
    setSelectedTicket(item);
    loadOldMessage(item?.id);
    connect(item?.id);
  };

  const getImage = (userId) => {
    const imageUrl = getObjectFromArrayOfObjects(
      customers,
      "id",
      userId
    )?.imageUrl;
    return imageUrl || PROFILE_PIC;
  };

  const getUserImage = (userId) => {
    const imageUrl = getObjectFromArrayOfObjects(users, "id", userId)?.imageUrl;
    return imageUrl || PROFILE_PIC;
  };

  const filteredTickets = completed?.filter((ticket) => {
    if (!search) return true;

    const searchValue = search.toString().toLowerCase();

    return (
      ticket.cartBundleId?.toString().toLowerCase().includes(searchValue) ||
      ticket.orderId?.toString().toLowerCase().includes(searchValue) ||
      ticket.referenceId?.toString().toLowerCase().includes(searchValue)
    );
  });

  const getTicketStatus = (status) => {
    switch (status) {
      case 0:
        return { bg: "#C8E2FB", clr: "#1976D2", title: "Placed" };
        break;
      case 1:
        return { bg: "#FFC89A", clr: "#D97706", title: "In Progress" };
        break;
      case 2:
        return "";
        break;
      case 3:
        return "";
        break;
      case 4:
        return "";
        break;
      case 5:
        return { bg: "#05966933", clr: " #059669", title: "Resolved" };
        break;
      default:
        return { bg: "#C8E2FB", clr: "#1447E6", title: "Placed" };
        break;
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* LEFT PANEL */}
        <div className={styles.left}>
          <input
            className={styles.searchInput}
            placeholder="Search tickets"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className={styles.listWrapper}>
            {search?.length > 0 ? (
              <>
                {filteredTickets?.length > 0 ? (
                  filteredTickets?.map((item) => (
                    <TicketTile
                      key={item.id}
                      data={item}
                      onClick={handleClick}
                      selectedTicket={selectedTicket}
                    />
                  ))
                ) : (
                  <div style={{ textAlign: "center" }}> Results Not Found</div>
                )}
              </>
            ) : (
              completed?.map((item) => (
                <TicketTile
                  key={item.id}
                  data={item?.ticket}
                  onClick={handleClick}
                  selectedTicket={selectedTicket}
                  unreadCount={item?.unseenCount}
                />
              ))
            )}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          className={styles.right}
          style={{
            width: showCustomerDetails ? "65%" : "100%",
            transition: "width 0.3s ease",
          }}
        >
          {selectedTicket?.id && (
            <div className={styles.rightWrapper}>
              {/* HEADER */}
              <div className={styles.top}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div>
                    <h3 className={styles.ticketTitle}>
                      Ticket ID {selectedTicket?.referenceId || "-"}
                    </h3>

                    <span
                      style={{
                        color: colors?.$primaryColor,
                        cursor: "pointer",
                        fontSize: "14px",
                        textDecoration: "underline",
                        textTransform: "capitalize",
                      }}
                      onClick={handleCustomerClick}
                    >
                      {getCustomerById(selectedTicket?.customerId)?.fullName ||
                        "Customer"}
                    </span>
                  </div>

                  <span
                    style={{
                      color: getTicketStatus(selectedTicket?.status)?.clr,
                      backgroundColor: getTicketStatus(selectedTicket?.status)
                        ?.bg,
                      padding: "6px 14px",
                      borderRadius: "16px",
                      height: "fit-content",
                      fontSize: "12px",
                    }}
                  >
                    {getTicketStatus(selectedTicket?.status)?.title}
                  </span>
                </div>
              </div>

              {/* CHAT AREA */}
              <div className={styles.chatArea}>
                <div className={styles.messageRow}>
                  <div className={styles.avatar}>
                    <div className={styles.avatarWrapper}>
                      <img
                        src={getImage(selectedTicket?.submittedUserId)}
                        className={styles.avatarImg}
                      />
                    </div>
                  </div>

                  <div
                    className={styles.messageLeft}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div>Subject : {selectedTicket?.subject || "NA"}</div>
                    <div>
                      Description : {selectedTicket?.description || "NA"}
                    </div>
                    {selectedTicket?.imageUrl && (
                      <div style={{ width: "200px" }}>
                        <img
                          src={selectedTicket?.imageUrl}
                          style={{ width: "100%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {messagesList?.length > 0 &&
                  messagesList?.map((msg, index) => (
                    <div
                      key={index}
                      className={
                        msg?.userId ? styles.messageRowRight : styles.messageRow
                      }
                    >
                      {msg?.customerId && (
                        <div className={styles.avatar}>
                          <div className={styles.avatarWrapper}>
                            <img
                              src={getImage(selectedTicket?.submittedUserId)}
                              className={styles.avatarImg}
                            />
                          </div>
                        </div>
                      )}

                      <div
                        className={
                          msg?.userId ? styles.messageRight : styles.messageLeft
                        }
                      >
                        {msg?.message}
                      </div>
                      {msg?.userId && (
                        <div className={styles.avatar}>
                          <div className={styles.avatarWrapper}>
                            <img
                              src={getUserImage(msg?.userId)}
                              className={styles.avatarImg}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                <div ref={chatEndRef} />
              </div>
            </div>
          )}
        </div>

        {showCustomerDetails && (
          <div
            style={{
              width: "320px",
              borderLeft: "1px solid #e0e0e0",
              background: "#ffffff",
              padding: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5>Customer Details</h5>
              <span
                style={{ cursor: "pointer", fontWeight: "bold" }}
                onClick={closeCustomerDetails}
              >
                ✕
              </span>
            </div>

            <div style={{ marginTop: "16px", textAlign: "center" }}>
              <img
                src={selectedCustomer?.imageUrl || PROFILE_PIC}
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: "10px",
                }}
              />

              <p style={{ textAlign: "left" }}>
                <b>Name:</b> {selectedCustomer?.fullName || "-"}
              </p>
              <p style={{ textAlign: "left" }}>
                {" "}
                <b>Email:</b> {selectedCustomer?.email || "-"}
              </p>
              <p style={{ textAlign: "left" }}>
                <b>Mobile:</b> {selectedCustomer?.phoneNumber || "-"}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  tickets: state?.supporttickets?.tickets,
  messages: state?.supporttickets?.messages,
  customers: state?.customer?.customers,
  loginUser: state?.login?.user, // logged-in user ID
  users: state?.user?.users,
});

export default connect(mapStateToProps)(CompletedTickets);
